module.exports = __webpack_public_path__ + "static/media/schoolSuffiles.d6036b31.png";